<template>
  <div class="tw:flex tw:items-center tw:justify-between tw:group">
    <div class="tw:flex tw:items-center tw:gap-2">
      <slot name="labelStart" />
      {{ label }}
    </div>
    <div
      class="tw:flex tw:font-normal"
      :class="{
        'tw:invisible tw:group-hover:visible': !active,
      }"
    >
      <BaseButton
        :color="active ? 'secondary' : 'form'"
        dense
        flat
        :icon="sortIcon"
        new-design
        new-icon
        @click="sortButtonClicked"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { BaseButton } from "shared/components/base";
import type { Nullable } from "shared/types";

export interface Props {
  sortBy: string;
  label: string;
}

type ModelSortDirection = Nullable<"asc" | "desc">;

interface Model {
  sortDirection: ModelSortDirection;
  sortBy: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: "",
});

const modelValue = defineModel<Model>({
  default: () => ({ sortBy: null, sortDirection: null }),
});

const sortIcon = computed<string>(() => {
  if (
    modelValue.value.sortBy !== props.sortBy ||
    modelValue.value.sortDirection === null ||
    modelValue.value.sortDirection === "asc"
  ) {
    return "sort-up";
  }

  return "sort-down";
});

const active = computed<boolean>(() =>
  Boolean(
    modelValue.value.sortBy === props.sortBy && modelValue.value.sortDirection
  )
);

function sortButtonClicked(): void {
  let sortDirection: ModelSortDirection = null;

  if (
    modelValue.value.sortBy !== props.sortBy ||
    modelValue.value.sortDirection === null
  ) {
    sortDirection = "asc";
  } else if (modelValue.value.sortDirection === "asc") {
    sortDirection = "desc";
  } else {
    sortDirection = null;
  }

  modelValue.value = {
    sortBy: props.sortBy,
    sortDirection,
  };
}
</script>
